import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDocumentCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatEnumValue } from '../activity-feed-v2/utils';

export interface DocumentCreatedEventProps {
  event: DiscriminatedDocumentCreatedEvent;
}

export const DocumentCreatedEvent: React.FC<DocumentCreatedEventProps> = ({
  event,
}) => {
  const { document } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <DocumentTextIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityTitle>
        {document.document_template?.name || 'New document'}
      </ActivityTitle>
      {(document.document_template as { category?: string })?.category && (
        <ActivityDescription>
          Type:{' '}
          {formatEnumValue(
            (document.document_template as { category?: string }).category!,
          )}
        </ActivityDescription>
      )}
    </ActivityBody>
  );

  const actions = document.id && (
    <ActivityActions>
      <ActivityLink href={`/${event.matter_id}#letters`}>
        View Agreements
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Agreement Added"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
